import { useState, useEffect, createContext } from "react";
import * as Utils from "../Utils/index";
import { ROLES } from "../Constants/Strings";

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = (user) => {
    Utils.setUser(user);
    setUser(user);
  };

  const logout = () => {
    Utils.removeCookie("user");
    setUser("");
  };

  const nonStaffAccess = [
    ROLES.MANAGING_DIRECTOR,
    ROLES.HEAD_OFFICE,
    ROLES.GOVERNMENT_OFFICER,
    ROLES.PROJECT_MANAGER,
    ROLES.PROJECT_ENGINEER,
  ].includes(user?.role);
  
  const isHeadOfficeAdmin = user?.role === ROLES.HEAD_OFFICE;
  const isManagingDirector = user?.role === ROLES.MANAGING_DIRECTOR;

  const values = {
    user,
    setUser,
    login,
    logout,
    nonStaffAccess,
    isHeadOfficeAdmin,
    isManagingDirector,
  };

  useEffect(() => {
    const fetchUser = async () => {
      const userData = await Utils.getUser();
      setUser(userData);
      setLoading(false);
    };

    fetchUser();
  }, []);

  if (!loading) {
    return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
  }
};

export default UserContextProvider;
